import { Base } from 'active-resource';
import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { EmployerResource } from './Employer';
import { PlanResource } from './Plan';

/**
 * Relationship classes
 */
export class SubscriptionAttributes {
  cancelAt: string = null;
  currentPeriodEnd: number = null;
  currentPeriodStart: number = null;
  freePlan: boolean = null;
  id: string = null;
  status: string = null;
  trialEnd: number = null;
  trialPeriodDays: number = null;
  trialStart: number = null;
}

export class SubscriptionBelongsTo {
  employer: () => EmployerResource = () => new EmployerResource();
  plan: () => PlanResource = () => new PlanResource();
}

export class SubscriptionHasOne {}
export class SubscriptionHasMany {}

/**
 * Utility interfaces
 */
export interface SubscriptionMethods {}

export interface SubscriptionInterface
  extends SubscriptionAttributes,
    SubscriptionBelongsTo,
    SubscriptionType {}

type SubscriptionType = GConstructor<SubscriptionInterface>;

export interface SubscriptionResource
  extends Base<SubscriptionAttributes>,
    SubscriptionInterface,
    SubscriptionMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<SubscriptionAttributes>({
    queryName: 'employers/subscriptions',
    className: 'Subscription',
    AttributesClass: SubscriptionAttributes,
    BelongsToClasses: [
      {
        Klass: SubscriptionBelongsTo,
      },
    ],
  });

export const SubscriptionResourceClass = <TBase extends SubscriptionType>(
  BaseConstructor: TBase,
): TBase => class extends BaseConstructor implements SubscriptionMethods {};

export class SubscriptionResource extends ClassExtender<SubscriptionInterface>(
  BaseClass,
  SubscriptionResourceClass,
) {}

/**
 * Resource instance
 */
export const Subscription = APILibrary.createResource<SubscriptionResource>(SubscriptionResource);
